import React from 'react';
import { Link } from 'react-router-dom';
import RedesignShell from './RedesignShell.jsx';
import EditorialArticle from './EditorialArticle.jsx';
import NewsletterSignup from '../NewsletterSignup.jsx';

/**
 * Shared layout for individual blog posts.
 * Pass metadata (title, date, category, readTime, image, excerpt) plus the
 * body as children. Body should use clean semantic HTML — no inline styles —
 * and will be styled by .articleA-prose.
 */
function BlogPostInner({ onNav, title, date, category, readTime, image, excerpt, children }) {
  return (
    <EditorialArticle
      navPage="blog"
      onNav={onNav}
      eyebrow={category}
      title={title}
      lead={excerpt}
      meta={
        <>
          {date && <span>{date}</span>}
          {readTime && <span>{readTime} read</span>}
        </>
      }
    >
      {image && (
        <section className="blogPostA-hero-img">
          <img src={image} alt={title} />
        </section>
      )}
      <section>
        <div className="articleA-prose">{children}</div>
      </section>
      <section>
        <div className="blogPostA-back">
          <Link to="/resources">← All resources</Link>
        </div>
        <NewsletterSignup />
      </section>
    </EditorialArticle>
  );
}

export default function BlogPostLayout(props) {
  return (
    <RedesignShell>
      {({ onNav }) => <BlogPostInner onNav={onNav} {...props} />}
    </RedesignShell>
  );
}
